var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareAlt = function SvgShareAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 40 41",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17 25.5a5.85 5.85 0 0 0 3.933-1.55l10.433 5.967c-.133.46-.2.937-.2 1.416a5.884 5.884 0 1 0 1.9-4.283l-10.433-5.966c.125-.411.193-.838.2-1.267l10.25-5.867a5.817 5.817 0 1 0-1.917-4.283c.006.479.073.955.2 1.417L14.053 16.5a5.834 5.834 0 1 0-4.884 9m20 3.334a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m0-21.667a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-20 10a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
  })));
};
export default SvgShareAlt;